// Only the languages onboarding workshops and resources are actually offered in.
// Academy's global filter list also includes JA and PT, which have no onboarding
// content yet.
export const AO_SUPPORTED_LANGUAGES = ['EN', 'ES', 'DE', 'FR'];